import simpleParallax from 'simple-parallax-js';

export default function initContentParallax() {
  let images = document.querySelectorAll('img.bg-image--top-left, .bg-image--top-left img');
  new simpleParallax(images,{
    orientation: 'down',
    delay: .2
  });
}
